import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/training/banner-opleidingen.png'
import _imports_1 from '@/assets/images/training/training-orderbeheer.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-10" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "img-fluid",
      alt: "banner"
    })
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "row my-5 justify-content-center"
}
const _hoisted_3 = { class: "col-xxl-8 text-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_6 = { class: "col-xxl-8" }
const _hoisted_7 = {
  class: "p-4",
  style: {"background-color":"#E8F4F8"}
}
const _hoisted_8 = { class: "row justify-content-between align-items-center" }
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = { class: "fw-700 fs-5 text-primary mb-3" }
const _hoisted_11 = { class: "fw-700 mb-2" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, " Op het einde van de opleiding kan je vragen stellen en gaan we dieper in op eventuele bemerkingen. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-fluid",
    alt: "orderbeheer"
  })
], -1)
const _hoisted_15 = {
  key: 2,
  class: "mt-4 mb-5 text-center"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-700 text-primary text-center" }, "Korte instructiefilmpjes")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center gx-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 mb-4" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/vbPGW4whi1I",
          target: "_blank"
        }, "Popups beheren")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/QYGp2ULhkRY",
          target: "_blank"
        }, "Richtprijsinstellingen aanpassen")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/6mj6Oh6itWE",
          target: "_blank"
        }, "Productgegevens importeren en exporteren")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/VxRjvvEiDq0",
          target: "_blank"
        }, "Kleurenschema aanpassen")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/_jjgQbI7ups",
          target: "_blank"
        }, "Tekst en titels aanpassen")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/5333L5GRmas",
          target: "_blank"
        }, "Pop-up weergeven bij de laatste stap van het checkout proces")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://youtu.be/SkZA5Jg_x5k",
          target: "_blank"
        }, "Mailings aanmaken en versturen")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 mb-4" }, [
    /*#__PURE__*/_createElementVNode("ul")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-700 text-primary text-center" }, "Opleidingen herbekijken")
], -1)
const _hoisted_20 = { class: "row justify-content-center gx-3" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "card-body text-center" }
const _hoisted_24 = { class: "text-muted small fw-700" }
const _hoisted_25 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_container = _resolveComponent("base-container")!

  return (this.isReady)
    ? (_openBlock(), _createBlock(_component_base_container, {
        key: 0,
        "position-center": ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (this.trainingsData?.welcome_txt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    innerHTML: this.trainingsData?.welcome_txt
                  }, null, 8, _hoisted_4)
                ])
              ]))
            : _createCommentVNode("", true),
          (this.trainingsData?.cb)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(this.trainingsData?.cb.title), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(this.trainingsData?.cb.subtitle), 1),
                          _createElementVNode("div", {
                            innerHTML: this.trainingsData?.cb.content
                          }, null, 8, _hoisted_12),
                          _hoisted_13
                        ])
                      ]),
                      _hoisted_14
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (this.trainingsData?.cb)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("a", {
                  href: this.trainingsData?.training_url,
                  target: "_blank",
                  class: "btn btn-primary fw-700"
                }, "VOLG HIER DE OPLEIDING", 8, _hoisted_16)
              ]))
            : _createCommentVNode("", true),
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.trainingsData?.videos, (video) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-6 col-xl-4 col-xxl-3 mb-4",
                key: video.id
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: 'https://img.youtube.com/vi/' + video.id + '/hqdefault.jpg',
                    class: "card-img-top",
                    alt: "yt-preview"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, _toDisplayString(video.title), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(video.date), 1)
                  ]),
                  _createElementVNode("a", {
                    href: 'https://www.youtube.com/watch?v=' + video.id,
                    class: "stretched-link",
                    target: "_blank"
                  }, null, 8, _hoisted_25)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}